<section class="sh-dialog__content">
    <p *ngIf="config.data.message" class="sh-preserve-linebreaks">{{config.data.message}}</p>
    <label for="label-input">{{config.data.batchTagDialogMessage}}</label>
    <input id="label-input" type="text" [(ngModel)]="batchTag" class="sh-input-field" />
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button *ngIf="config.data.yes" type="button" class="sh-button sh-action-group__item" (click)="yes()">{{ config.data.yes }}</button>
        <button *ngIf="config.data.no" type="button" class="sh-button--secondary sh-action-group__item" (click)="no()">{{ config.data.no }}</button>
    </div>
</footer>
